module.exports = __webpack_public_path__ + "static/gate-io-1ea85105b54049e9cbd41b1fcb31ca9e.png";